import React from 'react'

import services from '/components/services'
import { APIURL } from '/constants'
// import DefaultLayout from '/components/layouts/DefaultLayout'
 import BlankLayout from '/components/layouts/BlankLayout'
import Calculator from '/components/calculator/Calculator'

const CalculatorPage = ({ id, calculator }) => {
  return <Calculator id={id} calculator={calculator} />
}

CalculatorPage.Layout = BlankLayout

export const getServerSideProps = async (ctx) => {
  const { host } = ctx.req.headers
  const { slug } = ctx.query
  const cookie = ctx.req.headers.cookie || null
  const data = await services.get_v2(
    APIURL.API_CALCULATOR(slug),
    {},
    host,
    cookie
  )
  if (data.statusCode !== 200) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      slug,
      calculator: data.response
    }
  }
}

export default CalculatorPage
